// extracted by mini-css-extract-plugin
module.exports = {"loginBox":"LoginArea_loginBox__DvSNF","buttonBox":"LoginArea_buttonBox__22ROt"};